import React, { FC, useState } from 'react'

import { DecorationTitle, StandardButton } from 'src/components/atoms'
import { AssignTableWithSegmentedControls } from 'src/components/molecules/projects/AssignTableWithSegmentedControls'
import { EditCompassAssignModal } from 'src/components/organisms/projects/EditCompassAssignModal'

import { useAuthority } from 'src/hooks'
import { useGetCompassRoles } from 'src/hooks/useGetCompassRoles'
import { ProfileEntity, ProjectDetailEntity } from 'src/types'

type Props = {
  project: ProjectDetailEntity
  profile?: ProfileEntity
  className?: string
}

export const ProjectAssignDetail: FC<Props> = ({ project, profile, className }) => {
  const [editDefaultSelectedTab, setEditDefaultSelectedTab] = useState<'internal' | 'external'>(
    'internal'
  )
  const [isShowEditAssignModal, setIsShowEditAssignModal] = useState(false)

  const { compassRoles, loading: isCompassRolesLoading } = useGetCompassRoles()

  const { canAssignProject } = useAuthority()

  const showEditAssignModal = (type: 'internal' | 'external') => {
    setEditDefaultSelectedTab(type)
    setIsShowEditAssignModal(true)
  }

  return (
    <div className={className}>
      <div className="tw-grid tw-gap-s2">
        <div className="tw-full-justify">
          <DecorationTitle>アサイン</DecorationTitle>
          {canAssignProject && (
            <StandardButton
              text="編集"
              buttonType="secondary"
              prependIconPath="settings/soft/line"
              onClick={() => showEditAssignModal('internal')}
            />
          )}
        </div>

        <AssignTableWithSegmentedControls
          project={project}
          profile={profile}
          onClickToEditAssign={showEditAssignModal}
        />
      </div>

      {isShowEditAssignModal && profile && !isCompassRolesLoading && (
        <EditCompassAssignModal
          isOpen={isShowEditAssignModal}
          profile={profile}
          project={project}
          compassRoles={compassRoles}
          onClose={() => setIsShowEditAssignModal(false)}
          defaultSelectedTab={editDefaultSelectedTab}
        />
      )}
    </div>
  )
}
